import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../app/hooks';
import { useAppDispatch } from '../app/store';
import { setCurrentDate } from '../features/calendar/calendar-slice';
import { throttle, debounce } from 'lodash';
import { SvgIcon } from './svg-icon';

export const ScrollToTop = () => {
    const dispatch = useAppDispatch();
    const currentRange = useAppSelector(state => state.calendar.currentRange);
    const currentDate = useAppSelector(state => state.calendar.currentDate);
    const [showButton, setShowButton] = useState(false);
    const [pageHeight, setPageHeight] = useState(window.innerHeight);
    const scrollToTopButtonText = useAppSelector(state => state.settings.scrollToTopButtonText);

    useEffect(() => {
        document.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleResize);
        return () => {
            document.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    const handleScroll = throttle(() => setShowButton(window.pageYOffset > pageHeight), 250);
    const handleResize = debounce(() => setPageHeight(window.innerHeight), 250);

    const buttonClicked = () => {
        dispatch(setCurrentDate({
            newDate: currentRange.startDate,
            shouldChangeRange: false
        }));
    }

    return (
        <button type="button" onClick={buttonClicked} className="ace-cal-back-to-top btn-primary" data-show-button={showButton}>
            {scrollToTopButtonText}
            <SvgIcon iconId="arrow-right" />
        </button>
    )
}